module.exports = __webpack_public_path__ + "img/15.4d44a1bf.jpg";